module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_plamodel_80cf91d659b2ad33a5e0495b0b0ed784.png";